module.exports = __webpack_public_path__ + "img/racetrack-turffontein-turf-inner.87cd0403.svg";